module.exports = __webpack_public_path__ + "img/03.bb2e7c22.jpg";